import { EqlField } from 'generated/graphql';

export const isCommonMetadataField = (field: EqlField) => {
  return field.detail?.metadata?.source === 'Common';
};
